// File: src/components/enum/taskStatusEnum.ts

/**
 * Colunas do quadro kanban de tarefas. Os valores são exatamente os que o
 * backend espera (TypeTaskStatus).
 */
export enum TypeTaskStatus {
    TODO = 'TODO',
    IN_PROGRESS = 'IN_PROGRESS',
    DONE = 'DONE',
}

/** Ordem em que as colunas aparecem no quadro. */
export const TASK_COLUMNS: TypeTaskStatus[] = [
    TypeTaskStatus.TODO,
    TypeTaskStatus.IN_PROGRESS,
    TypeTaskStatus.DONE,
];

export const TaskStatusLabel: Record<TypeTaskStatus, string> = {
    [TypeTaskStatus.TODO]: 'A Fazer',
    [TypeTaskStatus.IN_PROGRESS]: 'Em Progresso',
    [TypeTaskStatus.DONE]: 'Concluído',
};

export const TaskStatusColor: Record<TypeTaskStatus, string> = {
    [TypeTaskStatus.TODO]: '#fbbf24',  // âmbar (ainda não começou)
    [TypeTaskStatus.IN_PROGRESS]: '#2b7bff',  // azul (em andamento)
    [TypeTaskStatus.DONE]: '#34d399',  // verde (concluído)
};
